<template>
  <div>
    <div
      v-if="isOffline"
      class="offline"
      v-bind:style="{
        top: `${this.$store.get('systems@PageHeight') - 26}px`,
        width: `${this.$store.get('systems@PageWidth') - 0}px`
      }"
    >
      App is offline (กรุณาตรวจสอบการเชื่อมต่อระบบ)
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import store from "../store/store";

import VueOffline from "vue-offline";
Vue.use(VueOffline);

@Component({
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";
    }
  }
})
export default class OnlineStatus extends Vue {}
</script>

<style lang="scss">
.offline {
  background-color: #fc9842;
  background-image: linear-gradient(315deg, #fc9842 0%, #fe5f75 74%);
  text-align: center;
  font-size: 18px;
  position: fixed;
  z-index: 999999999;
  top: 100px;
}
.online {
  background-color: #00b712;
  background-image: linear-gradient(315deg, #00b712 0%, #5aff15 74%);
  color: black;
}
</style>
